import { auth, analytics } from '@/plugins/firebase';
import * as DateTime from './date';

export async function analyticsLog(event, params) {
  let faParams = params;
  if (!faParams) faParams = {};

  faParams['ユーザーID'] = auth.currentUser ? auth.currentUser.uid : 'no user';
  faParams['時間'] = DateTime.format('yyyy/MM/dd HH:mm:ss', await DateTime.serverDate());

  analytics.logEvent(event, faParams);
}